import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onClickDelete } from 'actions/setting/emailNotification';
import styles from './ListRecipient.css';

class ListRecipient extends React.Component {
  render() {
    const { settingAlertRecipients } = this.props;
    return (
      <div>
        {settingAlertRecipients.map((recipient, idx) => {
          if (!recipient.is_added) {
            return <div key={recipient.id} />;
          }
          return (
            <div
              key={recipient.id}
              className={
                idx !== 0
                  ? `row ${styles['box-recipient']}`
                  : `row ${styles['box-recipient-disabled']}`
              }
            >
              <div
                className={
                  idx === 0 ? `col-xs-6` : `col-xs-6 ${styles['list-email']}`
                }
              >
                {recipient.email}
              </div>
              <div
                className={
                  idx === 0 ? `col-xs-4` : `col-xs-4 ${styles['list-status']}`
                }
              >
                {recipient.verified ? (
                  <div className={styles['status-verified']}>
                    <i
                      className={`fa fa-check-circle fa-lg fa-fw ${
                        styles['icon-verified']
                      }`}
                    />
                    Verified
                  </div>
                ) : (
                  recipient.id && (
                    <div className={styles['status-waiting']}>
                      Waiting for Verification
                    </div>
                  )
                )}
              </div>
              {idx > 0 && (
                <div className={`col-xs-2 ${styles['btn-delete']}`}>
                  <button
                    className="btn btn-danger"
                    onClick={event => this._onClickDelete(event, recipient)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  _onClickDelete = (event, deletedRecipient) => {
    event.stopPropagation();
    event.preventDefault();
    this.props.dispatch(onClickDelete(deletedRecipient));
  };
}

ListRecipient.propTypes = {
  settingAlertRecipients: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    data: state,
  };
}

export default connect(mapStateToProps)(ListRecipient);
